import { render, staticRenderFns } from "./TagFieldsHeader.vue?vue&type=template&id=4550c3da"
import script from "./TagFieldsHeader.vue?vue&type=script&lang=js"
export * from "./TagFieldsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports